const sectionCardMultiToolDoubleCss = `
[data-type='section-card-multi-tool-double'] * {
  box-sizing: border-box;
}

[data-type='section-card-multi-tool-double'] [data-attribute='card-container'] {
  color: var(--text-color, #000000);
}

[data-type='section-card-multi-tool-double'] [data-attribute='card-container'][data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-card-multi-tool-double'] [data-attribute='card-container'][data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-card-multi-tool-double'] .wrap-card {
  position: relative;
}

[data-type='section-card-multi-tool-double'] .wrap-card .swiper-button-next,
[data-type='section-card-multi-tool-double'] .wrap-card .swiper-button-prev {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #000000a1;
}

[data-type='section-card-multi-tool-double'] .wrap-card .swiper-button-next::after,
[data-type='section-card-multi-tool-double'] .wrap-card .swiper-button-prev::after {
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
}

[data-type='section-card-multi-tool-double'] .wrap-card .wrap-item {
  display: flex;
  flex-wrap: wrap;
  height: auto;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left[data-style-center-y='true'] {
  justify-content: center;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px 40px;
  border: solid 1px #d4dceb;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-rated {
  display: flex;
  gap: 8px;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-rated .wrap-stars {
  display: flex;
  gap: 4px;
  color: #c4c4c4;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-rated .wrap-stars svg {
  fill: #c4c4c4;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='1'] svg:nth-child(-n + 1),
[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='2'] svg:nth-child(-n + 2),
[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='3'] svg:nth-child(-n + 3),
[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='4'] svg:nth-child(-n + 4),
[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-rated .wrap-stars[data-value='5'] svg:nth-child(-n + 5) {
  color: #f0b100;
  fill: #f0b100;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-content {
  margin-bottom: 20px !important;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-content h1,
[data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-content h2,
[data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-content h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 9px 0 !important;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-content [data-attribute='card-description'] {
  font-size: 16px;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-content p {
  margin-bottom: 0;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-accordion {
  border-bottom: solid 1px #d4dceb;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-accordion .accordion-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-wrap: wrap;
  cursor: pointer;
  font-weight: bold;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-accordion .accordion-title div:first-child {
  width: calc(100% - 25px);
  font-size: 16px;
  font-weight: bold !important;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-accordion .accordion-title div:last-child {
  display: flex;
  border-radius: 50%;
  background-color: #000000;
  color: #ffffff;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-accordion .accordion-title div:last-child svg {
  display: block;
  width: 18px;
  height: auto;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-accordion .accordion-title div:last-child.open {
  transform: rotate(-180deg);
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-accordion .accordion-content {
  max-height: 0;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-accordion .accordion-content .accordion-text {
  padding: 10px;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .group-images-small {
  display: none;
  gap: 10px;
  align-items: center;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .group-images-small[data-show-imgsmall='true'] {
  display: flex !important;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .group-images-small .item-img {
  width: calc((100% - 20px) / 3);
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .group-images-small .item-img img {
  width: 100%;
  height: 100%;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .row-btn .card-btn {
  display: flex;
  border-radius: 5px;
  border: solid 1px var(--bg-color-btn, #f35c5c);
  text-decoration: none;
  color: #fff;
  padding: 10px 40px;
  font-size: 14px;
  font-weight: bold !important;
  line-height: 20px;
  align-items: center;
  column-gap: 10px;
  justify-content: center;
  transition: all 0.3s;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .row-btn .card-btn:hover {
  background-color: #ffffff !important;
  color: var(--bg-color-btn, #f35c5c) !important;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .row-btn .card-btn:hover .icon-btn {
  color: #ffffff !important;
  background-color: var(--bg-color-btn, #f35c5c) !important;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .row-btn .card-btn .icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #ffffff;
  color: var(--bg-color-btn, #f35c5c);
  transition: all 0.3s;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .row-btn .card-btn .icon-btn svg {
  display: block;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .row-btn .sub-btn {
  font-size: 14px;
  color: #070707;
  line-height: 20px;
  color: #070707;
  margin-top: 8px;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-item-with-icon .wrap-item {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-item-with-icon .wrap-item:last-child {
  margin-bottom: 0;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-item-with-icon .wrap-item .wrap-icon {
  width: 64px;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-item-with-icon .wrap-item .wrap-icon img {
  display: block;
  width: 100%;
  height: auto;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-item-with-icon .wrap-item .wrap-tex-icon {
  padding-left: 20px;
  width: calc(100% - 64px);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-item-with-icon .wrap-item .wrap-tex-icon .title-icon {
  font-size: 15px;
  font-weight: bold;
  line-height: normal;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-item-with-icon .wrap-item .wrap-tex-icon .description-icon {
  font-size: 14px;
  line-height: normal;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-survay .wrap-survay-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-survay .wrap-survay-item:last-child {
  margin-bottom: 0;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-survay .wrap-survay-item .left-item {
  width: 60px;
  position: relative;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-survay .wrap-survay-item .left-item svg {
  display: block;
  width: 100%;
  height: auto;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-survay .wrap-survay-item .left-item .wrap-percent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-survay .wrap-survay-item .right-item {
  width: calc(100% - 60px);
  padding-left: 20px;
  line-height: normal;
  font-size: 14px;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-survay .wrap-survay-item .right-item p {
  font-size: 14px;
  line-height: normal;
  margin-bottom: 0 !important;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-right {
  width: 50%;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-right .wrap-img {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

[data-type='section-card-multi-tool-double'] .wrap-card .card-right .wrap-img video {
  display: block;
  width: 100%;
  height: auto;
  min-height: 100%;
  object-fit: cover;
}

@container (max-width: 480px) {
  [data-type='section-card-multi-tool-double'] .wrap-card .swiper-button-next,
  [data-type='section-card-multi-tool-double'] .wrap-card .swiper-button-prev {
    top: 30%;
    width: 30px;
    height: 30px;
  }

  [data-type='section-card-multi-tool-double'] .wrap-card .swiper-button-next::after,
  [data-type='section-card-multi-tool-double'] .wrap-card .swiper-button-prev::after {
    font-size: 12px;
  }
}

@container (max-width: 768px) {
  [data-type='section-card-multi-tool-double'] [data-attribute='card-container'][data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-card-multi-tool-double'] [data-attribute='card-container'][data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-card-multi-tool-double'] .wrap-card .wrap-item {
    flex-direction: column;
  }

  [data-type='section-card-multi-tool-double'] .wrap-card .card-left[data-style-center-y='true'] [data-attribute='card-title'] {
    text-align: center;
  }

  [data-type='section-card-multi-tool-double'] .wrap-card .card-left {
    width: 100%;
    order: 2 !important;
    padding: 20px 16px;
    flex-grow: 1;
  }

  [data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-content h1,
  [data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-content h2,
  [data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-content h3 {
    font-size: 16px;
    line-height: 24px;
  }

  [data-type='section-card-multi-tool-double'] .wrap-card .card-left .card-content [data-attribute='card-description'] {
    font-size: 14px;
  }

  [data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-item-with-icon .wrap-item {
    margin-bottom: 16px;
  }

  [data-type='section-card-multi-tool-double'] .wrap-card .card-left .wrap-item-with-icon .wrap-item .wrap-tex-icon {
    padding-left: 16px;
  }

  [data-type='section-card-multi-tool-double'] .wrap-card .card-right {
    width: 100%;
    order: 1 !important;
  }

  [data-type='section-card-multi-tool-double'] .wrap-card .card-right .wrap-img {
    position: relative;
    overflow: hidden;
    aspect-ratio: 1/1.2;
    height: auto;
  }

  [data-type='section-card-multi-tool-double'] .wrap-card .card-right .wrap-img video {
    position: absolute;
    width: 100%;
    height: 100%;
    inset: 0;
    object-fit: cover;
  }
}
`;
export default sectionCardMultiToolDoubleCss;
